import React from 'react';
import { Flex, Text } from '@mantine/core';

interface DetailRowProps {
  icon: React.ComponentType<{ size?: number; className?: string }>;
  label: string;
  value: string | React.ReactNode;
  className?: string;
  iconSize?: number;
  layout?: 'horizontal' | 'vertical' | 'paragraph';
}

export function DetailRow({ 
  icon: Icon, 
  label, 
  value, 
  className = '', 
  iconSize = 18,
  layout = 'horizontal'
}: DetailRowProps) {
  const colorClass = "text-dark-700 dark:text-gray-600"
  
  if (layout === 'vertical') {
    return (
      <div className={`flex flex-col gap-2 ${className}`}>
        <div className="flex items-center gap-2">
          <Icon size={iconSize} className={colorClass} />
          <Text size="sm" fw={600} className={colorClass}>
            {label}
          </Text>
        </div>
        <div className="pl-6">
          {typeof value === 'string' ? (
            <Text size="md">{value}</Text>
          ) : (
            value
          )}
        </div>
      </div>
    );
  }

  if (layout === 'paragraph') {
    return (
      <div className={`flex flex-col gap-2 ${className}`}>
        <div className="flex items-center gap-2">
          <Icon size={iconSize} className={colorClass} />
          <Text size="sm" fw={600} className={colorClass}>
            {label}
          </Text>
        </div>
        <Flex pl="lg">
          {typeof value === 'string' ? (
            <Text size="md">{value}</Text>
          ) : (
            value
          )}
        </Flex>
      </div>
    );
  }

  return (
    <div className={`flex items-center justify-between ${className}`}>
      <div className="flex items-center gap-2">
        <Icon size={iconSize} className={colorClass} />
        <Text size="sm" fw={600} className={colorClass}>
          {label}
        </Text>
      </div>
      <div className="text-right">
        {typeof value === 'string' ? (
          <Text size="md">{value}</Text>
        ) : (
          value
        )}
      </div>
    </div>
  );
} 